import { useEffect } from "react";
import "@/App.css";
import { camp } from "@/data/camp";
import SiteHeader from "@/components/SiteHeader";
import HeroSection from "@/components/HeroSection";
import RegistrationModal from "@/components/RegistrationModal";
import { PaymentCancelPage, PaymentSuccessPage } from "@/components/PaymentPages";
import {
  QuickInfoSection,
  EditorialMarquee,
  ExperienceSection,
  ManifestoSection,
  ScheduleSection,
  CoachesSection,
} from "@/components/CampSections";
import {
  AudienceSection,
  InclusionsSection,
  VenueSection,
  AboutSection,
  ParentsSection,
} from "@/components/DetailsSections";
import FAQSection from "@/components/FAQSection";
import FooterSection, { FinalCtaSection } from "@/components/FooterSection";

function HomePage() {
  useEffect(() => {
    const description = document.querySelector('meta[name="description"]');
    const socialDescription = document.querySelector('meta[property="og:description"]');
    if (description) description.setAttribute("content", `Alabama Elite Junior Golf Camp on ${camp.date} at Oak Mountain State Park Golf Course in Birmingham, Alabama. Train, compete, and learn alongside high-level collegiate golfers.`);
    if (socialDescription) socialDescription.setAttribute("content", `A one-day elite junior golf experience in Birmingham, Alabama. ${camp.date}.`);
  }, []);

  return (
    <div className="App">
      <SiteHeader />
      <main>
        <HeroSection />
        <QuickInfoSection />
        <EditorialMarquee />
        <ExperienceSection />
        <ManifestoSection />
        <ScheduleSection />
        <CoachesSection />
        <AudienceSection />
        <InclusionsSection />
        <VenueSection />
        <AboutSection />
        <ParentsSection />
        <FAQSection />
        <FinalCtaSection />
      </main>
      <FooterSection />
      <RegistrationModal />
    </div>
  );
}

function App() {
  if (window.location.pathname.startsWith("/payment/success")) return <PaymentSuccessPage />;
  if (window.location.pathname.startsWith("/payment/cancel")) return <PaymentCancelPage />;
  return <HomePage />;
}

export default App;
